export const enum ExpressionType {
  // Form Builder
  ComponentValidation = "ComponentValidation",
  FromValidation = "FormValidation",
  ExpressionComponent = "ExpressionComponent",
  Reference = "Reference",
  DropdownFilter = "DropdownFilter",
  GridRow = "GridRow",
  FetchButton = "FetchButton",
  GridDropdownFilter = "GridDropdownFilter",
  ActionButtonUrl = "ActionButtonUrl",
  // Flow Builder
  Condition = "Condition",
  SpecificUser = "SpecificUser",
  SpecificRole = "SpecificRole",
  UserReportLine = "UserReportLine",
}

export const DEFAULT_EXPRESSION_TEMPLATE = `function expression(){
  return 'any';
}`;

export const DEFAULT_SUMMARY_EXPRESSION_TEMPLATE = `function expression(){
  return '';
}`;

export const ExpressionDefault = {
  [ExpressionType.ComponentValidation]:
    "function validation(value) {\n // return boolean or {isValid: boolean, error: string}\n return true;\n}",
  [ExpressionType.SpecificUser]: `function expression(){\n  // must return an array of user code (string array).\n // return [String(getFormField("field_name").value)]\n  return getFormField("field_name").value?.map((v)=>String(v));\n}`,
  [ExpressionType.SpecificRole]: `function expression(){\n  // must return an array of role code (string array).\n // return [String(getFormField("field_name").value)]\n  return getFormField("field_name").value?.map((v)=>String(v));\n}`,
  [ExpressionType.UserReportLine]: `function expression(){\n  // must return a user code (string).\n // return String(getFormField("field_name").value);\n}`,
  [ExpressionType.GridRow]: `function rowExpression(row){
  // this function can return any type of value
  // row will return {column_key_1, column_key_2}
  return 'any';
}`,
  [ExpressionType.GridDropdownFilter]:
    "function filter(value, row){\n  // value: the table record being filtered\n  // row: the current grid row data\n  // must return a boolean value\n  return true;\n}",
  [ExpressionType.ExpressionComponent]: `function expression(){\n // getFormField("field_name").value\n // supports: external api\n return "any";\n}`,
  [ExpressionType.ActionButtonUrl]: `function expression(){
  // return "https://" + getFormField("field_name").value + ".com";
  return "https://www.giant-bicycles.com/tw"
}`,
  [ExpressionType.Reference]: `function expression(){
  // return any type of value
  // return getFormFiled("field_name").value
  return 'any';
}`,
  [ExpressionType.DropdownFilter]:
    "function filter(value){\n  // value: the table record being filtered\n  // must return a boolean value\n  return true;\n}",
};
